import { ProductInfoBox as CoreProductInfoBox } from 'core/components'
import { TmrProduct } from 'stylewhere/api'

export class ProductInfoBox extends CoreProductInfoBox {
  getProductCode(product?: TmrProduct): string {
    return product?.code ?? '---'
  }

  render() {
    return <CoreProductInfoBox {...this.props} disabledDescription />
  }
}
